import EmployerWorkerViewProfile from "../../components/edit_details/employer_workerview_profile";
import EmployerHeader from "../../components/edit_details/worker_employerview_header";
import { useSelector } from "react-redux";
function EmployerFullHead() {
  const publicInfo = useSelector(e => e.public);
  const pub = publicInfo.message?.profile;

  return (
    <>
      {/* top purple header and About of page  */}
      <div className="w-full  tablet:flex gap-6">
        <EmployerWorkerViewProfile />
        {/* About page  */}
        <div className="flex flex-col gap-10 w-full tablet:w-[50%]">
          <div className="bg-white rounded-xl border border-[#D2D4F8] p-5 w-full h-fit flex justify-between">
            {/* content  */}
            <div className="w-[90%]">
              <h1 className="text-[#5843BD] font-semibold text-base">About</h1>
              <p className=" text-sm font-normal text-[#666666] w-fit h-fit">
                {pub?.About}
              </p>
            </div>

            {/* edit icon  */}
            {/* <div>
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.4971 10.0058C19.2319 10.0058 18.9775 10.1112 18.79 10.2987C18.6024 10.4862 18.4971 10.7406 18.4971 11.0058V17.0058C18.4971 17.271 18.3917 17.5254 18.2042 17.7129C18.0166 17.9004 17.7623 18.0058 17.4971 18.0058H3.49707C3.23185 18.0058 2.9775 17.9004 2.78996 17.7129C2.60243 17.5254 2.49707 17.271 2.49707 17.0058V3.0058C2.49707 2.74058 2.60243 2.48623 2.78996 2.29869C2.9775 2.11116 3.23185 2.0058 3.49707 2.0058H9.49707C9.76229 2.0058 10.0166 1.90044 10.2042 1.71291C10.3917 1.52537 10.4971 1.27101 10.4971 1.0058C10.4971 0.740582 10.3917 0.486228 10.2042 0.298692C10.0166 0.111155 9.76229 0.00579834 9.49707 0.00579834H3.49707C2.70142 0.00579834 1.93836 0.321869 1.37575 0.884478C0.813141 1.44709 0.49707 2.21015 0.49707 3.0058V17.0058C0.49707 17.8014 0.813141 18.5645 1.37575 19.1271C1.93836 19.6897 2.70142 20.0058 3.49707 20.0058H17.4971C18.2927 20.0058 19.0558 19.6897 19.6184 19.1271C20.181 18.5645 20.4971 17.8014 20.4971 17.0058V11.0058C20.4971 10.7406 20.3917 10.4862 20.2042 10.2987C20.0166 10.1112 19.7623 10.0058 19.4971 10.0058ZM4.49707 10.7658V15.0058C4.49707 15.271 4.60243 15.5254 4.78996 15.7129C4.9775 15.9004 5.23185 16.0058 5.49707 16.0058H9.73707C9.86868 16.0066 9.99914 15.9813 10.121 15.9316C10.2428 15.8818 10.3536 15.8085 10.4471 15.7158L17.3671 8.7858L20.2071 6.0058C20.3008 5.91284 20.3752 5.80223 20.426 5.68038C20.4767 5.55852 20.5029 5.42781 20.5029 5.2958C20.5029 5.16379 20.4767 5.03308 20.426 4.91122C20.3752 4.78936 20.3008 4.67876 20.2071 4.5858L15.9671 0.295798C15.8741 0.20207 15.7635 0.127676 15.6416 0.0769069C15.5198 0.0261382 15.3891 0 15.2571 0C15.1251 0 14.9944 0.0261382 14.8725 0.0769069C14.7506 0.127676 14.64 0.20207 14.5471 0.295798L11.7271 3.1258L4.78707 10.0558C4.69439 10.1492 4.62106 10.2601 4.5713 10.3819C4.52153 10.5037 4.49631 10.6342 4.49707 10.7658ZM15.2571 2.4158L18.0871 5.2458L16.6671 6.6658L13.8371 3.8358L15.2571 2.4158ZM6.49707 11.1758L12.4271 5.2458L15.2571 8.0758L9.32707 14.0058H6.49707V11.1758Z"
                  fill="#FF6633"
                />
              </svg>
            </div> */}
          </div>

          {/* info and Location  */}
          <div className="w-full flex justify-between gap-4">
            {/* info  */}
            {pub?.Years_of_experience !== null && pub?.Years_of_experience !== undefined ?
            <div className=" w-[40%] bg-white rounded-xl border border-[#D2D4F8] p-5">
            <h1 className="text-[#5843BD] font-semibold text-base">Info</h1>
            <p className=" text-xs font-normal text-[#666666]">
              {pub?.Years_of_experience} years of experience
            </p>
          </div> : null}
            {/* location  */}
            {pub?.Address !== null && pub?.Address !== undefined ? 
            <div className="w-[40%] bg-white rounded-xl border border-[#D2D4F8] p-5">
            <h1 className="text-[#5843BD] font-semibold text-base">
              Location
            </h1>
            <p className=" text-xs font-normal text-[#666666]">
             {pub?.Address}
            </p>
          </div> : null}
          </div>

          {/* Button and review  */}
          <div className="w-full flex flex-col gap-4 tablet:flex-row tablet:gap-0 justify-between">
            <button className=" bg-[#E1DCF9] border border-[#5843BD] hover:text-[#ffffff] hover:bg-[#5843BD] hover:border-[#ffffff] px-5 py-3 rounded-2xl text-[#5843BD] whitespace-nowrap font-semibold text-base">
              Send Message
            </button>
            <button className=" bg-[#F5F4FC] border  hover:text-[#ffffff] hover:bg-[#5843BD] hover:border-[#ffffff] px-5 py-3 rounded-2xl text-[#5843BD] whitespace-nowrap font-semibold text-base">
              Request Review
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployerFullHead;